import jwtDecode from "jwt-decode";

export const LOCALSTORAGE_ACCESS_TOKEN_KEY = "userToken";
export const LOCALSTORAGE_REFRESH_TOKEN_KEY = "refreshToken";

export const TOKEN_KEY_FIRM_ID = "http://www.t-p.com/FIRM_ID";
export const TOKEN_KEY_IADRNR = "http://www.t-p.com/IADRNR";
export const TOKEN_KEY_LBNR = "http://www.t-p.com/LBNR";
export const TOKEN_KEY_SPRACHE = "http://www.t-p.com/SPRACHE";
export const TOKEN_KEY_UEBERGEORDNETE_SPRACHE = "http://www.t-p.com/UEBERGEORDNETE_SPRACHE";

class TokenHelper {

  getLocalRefreshToken() {
    const encodedToken = localStorage.getItem(LOCALSTORAGE_REFRESH_TOKEN_KEY);
    let decodedToken = null;
    try {
      decodedToken = jwtDecode(encodedToken);
    } catch {
      decodedToken = null;
    }

    return {
      encodedToken: encodedToken,
      decodedToken: decodedToken,
    };
  }

  setLocalRefreshToken(value) {
    // For debugging: const decodedValue = jwtDecode(value);
    localStorage.setItem(LOCALSTORAGE_REFRESH_TOKEN_KEY, value);
  }

  getLocalAccessToken() {
    const encodedToken = localStorage.getItem(LOCALSTORAGE_ACCESS_TOKEN_KEY);
    let decodedToken = null;
    try {
      decodedToken = jwtDecode(encodedToken);
    } catch {
      decodedToken = null;
    }

    return {
      encodedToken: encodedToken,
      decodedToken: decodedToken,
    };
  }

  setLocalAccessToken(value) {
    // For debugging: const decodedValue = jwtDecode(value);
    localStorage.setItem(LOCALSTORAGE_ACCESS_TOKEN_KEY, value);
  }

  clearTokens() {
    localStorage.removeItem(LOCALSTORAGE_ACCESS_TOKEN_KEY);
    localStorage.removeItem(LOCALSTORAGE_REFRESH_TOKEN_KEY);
  }
}

const tokenHelper = new TokenHelper();

export default tokenHelper;
